import { PageFilterIdentifier } from '../../constants/page-filter-identifiers';
import {
  FilterParamQueries,
  UserId,
} from '../../interfaces/filters.interfaces';

export class SaveUserFilterQueryParamsInCache {
  static readonly type = '[FilterSettings] Save URL Filter Query Params Value';
  constructor(
    public userId: UserId,
    public pageId: PageFilterIdentifier,
    public filterParamQueries: FilterParamQueries,
  ) {}
}

export class RemoveUserFilterPageIdQueryParamsFromCache {
  static readonly type =
    '[FilterSettings] Remove URL Filter Query Params Value';
  constructor(
    public userId: UserId,
    public pageId: PageFilterIdentifier,
  ) {}
}
